import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { presentFormatedData, presentDate } from '../../../functionalComponents/dataFormatFunctions';

const useStyles = makeStyles((theme) => ({
  font: {
    fontWeight: 600,
    textAlign: 'initial',
    paddingBottom: '0.25rem',
    fontSize: '1rem',
  },
  fontPadding: {
    textAlign: 'initial',
    overflow: 'auto',
    paddingTop: '0.25rem',
    fontSize: '1rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },
  rowContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const ProducedBatchInformation = (props) => {
  const classes = useStyles();
  const { batchDetails, selectedBatch } = props;
  

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={8} sm={12} md={12} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            Produced Batch Information
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails.vendorBatchNumber && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Produced Batch Number
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.vendorBatchNumber)}
              </Typography>
            </Grid>
          )}
          {batchDetails.manufacturingDate && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Date of Manufacturing
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentDate(batchDetails.manufacturingDate)}
              </Typography>
            </Grid>
          )}
          {batchDetails.expiryDate && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Product Expiry Date
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentDate(batchDetails.expiryDate)}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails?.producedQuantity !== null && batchDetails?.producedQuantity !== undefined && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Produced Quantity
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails?.producedQuantity)}
              </Typography>
            </Grid>
          )}
          {batchDetails?.batchUOM !== null && batchDetails?.batchUOM !== undefined && batchDetails?.batchUOM !== '' && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Product UoM
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails?.batchUOM)}
              </Typography>
            </Grid>
          )}
          {batchDetails?.supplierConfirmationControlKey !== null &&
           batchDetails?.supplierConfirmationControlKey !== undefined &&
           batchDetails?.supplierConfirmationControlKey !== '' && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Confirmation Control Key
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.supplierConfirmationControlKey)}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails.vendorPlant && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Sponsor Product Receiving Plant ID
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.vendorPlant)}
              </Typography>
            </Grid>
          )}
          {batchDetails.storageLocation && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Sponsor Product Receiving Storage Location ID
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.storageLocation)}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <hr />
    </React.Fragment>
  );
};

export default ProducedBatchInformation;